import * as Selectors from "./SolutionSelectors";
import { SavedItemsRequest } from "../../../Models";
import { GeneralState } from "..";
import { CalculateMulticoteSolutionsResultRequest } from "../../../Models/ServerModels/Calculations/CalculateMulticoteSolutionsResultRequest";
import { SolutionState } from "../..";
import { shareableItemTypes } from "../../../Utils/Enums";

export const getSavedItemsRequest = (getState: any): SavedItemsRequest => {
    const state = getState();
    const itemId = Selectors.selectItemId(state);
    const itemName = Selectors.selectItemName(state);
    const plantingDate = Selectors.selectPlantingDate(state);
    const { activeMetricMethod } = GeneralState.Selectors.selectMetricMethods(state);
    const { temperatures } = Selectors.selectTemperatureState(state);

    const releaseGraphState = Selectors.selectReleaseGraphState(state);

    const selectedNutrient = SolutionState.Selectors.selectNutrientType(state);
    const blendObject = SolutionState.Selectors.selectBlendObject(state);
    return {
        savedItemId: itemId,
        name: itemName,
        countryCode: null,
        cropCode: null,
        yieldValue: null,
        mesurementUnitCode: activeMetricMethod,
        startingDate: plantingDate as string,
        farmerPractice: {
            n: null,
            p: null,
            k: null,
        },
        cropDemand: {
            n: null,
            p: null,
            k: null,
        },
        finishDate: null,
        soilId: 1,
        waterId: 1,
        months: temperatures,
        userSaved: true,
        userShareItem: releaseGraphState.isUserShare,
        step: 5,
        isAgriItem: false,
        longitude: null,
        latitude: null,
        multicoteBlendId: blendObject && blendObject.id ? blendObject.id : null,
        multicoteNutrientType: selectedNutrient ? selectedNutrient : null,
        displayReadyMadeGraphType: shareableItemTypes.multicote,
    };
};

export const getMulticoteCalculationRequest = (getState: any): CalculateMulticoteSolutionsResultRequest => {
    const state = getState();
    const itemId = Selectors.selectItemId(state);
    const { activeMetricMethod } = GeneralState.Selectors.selectMetricMethods(state);
    const blendObject = SolutionState.Selectors.selectBlendObject(state);
    const selectedNutrient = SolutionState.Selectors.selectNutrientType(state);
    const plantingDate = SolutionState.Selectors.selectPlantingDate(state);
    const { temperatures } = SolutionState.Selectors.selectTemperatureState(state);

    return {
        SavedItemId: itemId,
        BlendId: blendObject && blendObject.id ? blendObject.id : 1,
        NutrientType: selectedNutrient as string,
        MesurementUnitCode: activeMetricMethod,
        StartingDate: plantingDate as string,
        Months: temperatures,
    };
};
